/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { getDeviceTypesAPI } from 'HierarchiesAPI';

/**
 * /** this custom hook translates an entityTypeName to entityTypeUUID
 * TODO: we should be able to replace this once the Monitor pages are updated
 * @param {string} entityTypeName name of the entity type
 * @param {string} userEmailId email id of the user
 * @param {*} deviceTypes
 * @returns
 */
export const useEntityTypeName = (entityTypeName, userEmailId, deviceTypes) => {
  const [deviceType, setDeviceType] = useState();
  const [entityTypes, setEntityTypes] = useState();

  useEffect(() => {
    const foundDeviceType =
      Array.isArray(deviceTypes) && !isEmpty(deviceTypes)
        ? deviceTypes.find(entityType => entityType.name === entityTypeName)
        : undefined;

    if (foundDeviceType) {
      setDeviceType(foundDeviceType);
      setEntityTypes(deviceTypes);
    } else {
      getDeviceTypesAPI(userEmailId).then(response => {
        setDeviceType(
          Array.isArray(response?.results)
            ? response?.results?.find(entityType => entityType?.name === entityTypeName)
            : undefined
        );
        setEntityTypes(response?.results);
      });
    }
  }, [entityTypeName, deviceTypes, userEmailId]);
  return [deviceType?.uuid, entityTypes, deviceType];
};
